<template>
  <div
    class="keywords-filter-list__item"
  >
    <el-checkbox v-model="enabled" @change="enableKeyWord" />
    <div class="keywords-filter-list__item--left">
      <el-input v-model="keyword" :placeholder="$t('feed.settings.keys.placeholder')" @change="editKeyWord">
        <i slot="suffix" class="el-input__icon el-icon-delete-solid el-icon-cursor" @click="deleteKeyWordFilter"></i>
      </el-input>
      <el-checkbox-group v-model="networks" @change="handleCheckedNetworksChange">
        <el-checkbox v-for="item in networksList" :label="item" :key="item">{{item}}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'KeysFilterItem',
    props: {
      item: {
        type: Object
      },
      index: {
        type: Number
      },
      referencesNetworks: {
        type: Array
      }
    },
    data() {
      return {
        id: this.item.id,
        enabled: this.item.enabled,
        keyword: this.item.keyword,
        networks: [],
        networksList: []
      };
    },
    computed: {
      ...mapGetters([
        'isAdmin',
      ]),
      isEnabledKeyWords() {
        return this.keyWordsFilterForm.keywords.length;
      },
      keyWordsFilterForm: {
        get() {
          if (!this.keywords.length) {
            this.$emit('addKeyWordFilter');
          }

          return {
            keywords: this.keywords.slice()
          };
        },
      }
    },
    methods: {
      deleteKeyWordFilter() {
        this.$emit('deleteKeyWordFilter', this.index);
      },
      enableKeyWord() {
        if (this.enabled) {
          this.networks = [...this.networksList];
        } else {
          this.networks = [];
        }
        const options = {
          index: this.index,
          enabled: this.enabled
        }
        this.handleCheckedNetworksChange();
        this.$emit('enableKeyWord', options);
      },
      editKeyWord() {
        const options = {
          index: this.index,
          keyword: this.keyword
        }
        this.$emit('editKeyWord', options);
      },
      handleCheckedNetworksChange() {
        const networks = [];
        this.networks.forEach(it => {
          networks.push(Number(this.referencesNetworks.find(item => item.name == it).id))
        })
        const options = {
          index: this.index,
          networks
        }
        this.$emit('choiceNetwork', options);
      },
    },
    beforeMount() {
      this.referencesNetworks.forEach(it => {
        if (it.id != 11 || this.isAdmin)
        {this.networksList.push(it.name);
        const isEnabled = this.item.networks.includes(Number(it.id));
        if (isEnabled) {
          this.networks.push(it.name);
        }}
      })
    }
  };
</script>

<style>
  .keywords-filter-list__item {
    display: flex;
    align-items: flex-start;
    width: calc(50% - 15px);
  }
  .keywords-filter-list__item:not(:last-child) {
    /*padding-bottom: 10px;*/
    margin-bottom: 25px;
    /*border-bottom: 1px solid rgba(0,0,0,0.2);*/
  }
  .keywords-filter-list__item > .el-checkbox {
    flex-shrink: 0;
    margin: 10px 10px 0 0;
  }
  .keywords-filter-list__item--left {
    flex-grow: 1;
  }
  .keywords-filter-list__item--left .el-checkbox {
    margin: 5px 15px 0 0;
  }
  .keywords-filter-list__item--left .el-checkbox-group {
    margin: 5px 0 0 0;
  }
  .keywords-filter-list__item .el-checkbox__label {
    padding-left: 6px;
    font-size: 12px;
  }
  .el-icon-cursor {
    cursor: pointer;
  }
</style>
